export default function moveItem(array, index, direction) {
  if (!Array.isArray(array)) return array;
  const newArray = [...array];
  const targetIndex = direction === 'up' ? index - 1 : index + 1;
  
  if (targetIndex < 0 || targetIndex >= newArray.length) {
    return array; // out of bounds
  }
  
  const temp = newArray[index];
  newArray[index] = newArray[targetIndex];
  newArray[targetIndex] = temp;
  return newArray;
}
